class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.menuZone = this.closest('li') || this;
    this.menuZone.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.menuZone.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.content.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.content.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    document.addEventListener('click', this.onDocumentClick.bind(this));
    document.addEventListener('keydown', this.onDocumentKeydown.bind(this));
  }

  onMouseEnter() {
    if (!window.matchMedia('(hover: hover)').matches) return;
    clearTimeout(this.closeTimer);

    document.querySelectorAll('header-menu details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
        details.querySelector('summary').setAttribute('aria-expanded', false);
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    if (!window.matchMedia('(hover: hover)').matches) return;
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      if (this.menuZone.matches(':hover') || this.content.matches(':hover')) return;
      this.close();
    }, 300);
  }

  close() {
    clearTimeout(this.closeTimer);
    super.close();
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  onDocumentKeydown(event) {
    if (event.key === 'Escape') this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);